import { render, staticRenderFns } from "./TaskDrawer.vue?vue&type=template&id=63bbb2db&scoped=true"
import script from "./TaskDrawer.vue?vue&type=script&lang=js"
export * from "./TaskDrawer.vue?vue&type=script&lang=js"
import style0 from "./TaskDrawer.vue?vue&type=style&index=0&id=63bbb2db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bbb2db",
  null
  
)

export default component.exports